import { Stack, Table } from "@mantine/core";

import { BillingTabsEnum, getClientBillingTabPath } from "@/billing/constants/billing-tabs";
import { EMPTY_VALUE } from "@/billing/constants/empty-value";
import AnchorLink from "@/clients/components/AnchorLink";
import { TextWrapper } from "@/components/TextWrapper";
import { formatCurrency } from "@/utils/billing";
import { usDateFormat } from "@/utils/datetime";

import type { PracticeLedgerTableRowProps } from "./types/ledger-ui";

export default function LedgerTableRow({ row }: PracticeLedgerTableRowProps) {
  return (
    <Table.Tr data-testid={`practice-ledger-row-${row.id}`}>
      <Table.Td>
        <Stack gap={0}>
          <AnchorLink
            fw={700}
            c="burgundy.9"
            data-testid={`practice-ledger-row-open-client-${row.id}`}
            to={getClientBillingTabPath(row.clientId, BillingTabsEnum.PAYMENTS)}
          >
            {row.clientName}
          </AnchorLink>
          <TextWrapper c="gray.6">{row.medicalRecordNumber}</TextWrapper>
        </Stack>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{row.type}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{usDateFormat(row.transactionDate)}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{row.sourceLabel}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper ta="right">{formatCurrency(row.amount)}</TextWrapper>
      </Table.Td>
      <Table.Td>
        <TextWrapper>{row.statementId ?? EMPTY_VALUE}</TextWrapper>
      </Table.Td>
    </Table.Tr>
  );
}
